// source: section.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.itp.Section', null, global);
/**
 * @enum {number}
 */
proto.itp.Section = {
  NOSECTION: 0,
  MENTORFORAMINUTE: 1,
  ABOUT: 2,
  CAREERONESTOP: 3,
  ADAYINTHELIFE: 4,
  PATHWAYMAIN: 5,
  PODCAST: 6,
  RESOURCES: 7,
  LINKS: 8
};

goog.object.extend(exports, proto.itp);
